module.exports = __webpack_public_path__ + "static/media/20-5.46dedd42.mp3";